'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeClientTriggers = undefined;

var _postStopTrackScrollPercentage = require('../../scroll-percentage-trigger/actions/postStopTrackScrollPercentage');

var _removeTimeOnPageTrigger = require('../../time-on-page-trigger/actions/removeTimeOnPageTrigger');

var _postStopTrackExitIntent = require('../../exit-intent-trigger/actions/postStopTrackExitIntent');

var removeClientTriggers = exports.removeClientTriggers = function removeClientTriggers() {
  return function (dispatch) {
    dispatch((0, _postStopTrackScrollPercentage.postStopTrackScrollPercentage)());
    dispatch((0, _removeTimeOnPageTrigger.removeTimeOnPageTrigger)());
    dispatch((0, _postStopTrackExitIntent.postStopTrackExitIntent)());
  };
};